import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/types/common';
import { UnitsState } from '@/types/units';

export interface ActivityLocation {
  activityId: number;
  // Same shape the `unit` slice's selectedTopic/selectedUnit already use, so
  // the correction effect can dispatch these straight through with no lookup.
  topic: UnitsState['selectedTopic'];
  activitiesInTopic: number | undefined;
  unit: UnitsState['selectedUnit'];
  level: number;
}

export interface ActivityLocationsState {
  byActivityId: Record<number, ActivityLocation>;
}

const initialState: ActivityLocationsState = {
  byActivityId: {},
};

const activityLocations = createSlice({
  name: 'activityLocations',
  initialState,
  reducers: {
    setActivityLocation: (state, action: PayloadAction<ActivityLocation>) => {
      state.byActivityId = {
        ...state.byActivityId,
        [action.payload.activityId]: action.payload,
      };
    },
  },
});

export const activityLocationsActions = activityLocations.actions;
export const activityLocationsSelector = (state: RootState) => state.activityLocations;
export default activityLocations.reducer;
